import React from 'react';
import './StatCard.css';

/** Frosted-glass stat tile with a gradient number. */
export default function StatCard({ value, label }) {
  return (
    <div className="stat-card">
      <span className="stat-card__value gradient-text">{value}</span>
      <span className="stat-card__label">{label}</span>
    </div>
  );
}
